/**
 * Las dos opciones al cambiar un día: solo ese, o el resto del grupo.
 * El mismo gesto que al soltar una cita en el mes.
 */
import { useEffect, useRef } from 'react'

export function PreguntaAlcanceHorario({
    x,
    y,
    alSoloEste,
    alResto,
    alCerrar,
}: {
    x: number
    y: number
    alSoloEste: () => void
    alResto: () => void
    alCerrar: () => void
}) {
    const caja = useRef<HTMLDivElement>(null)

    useEffect(() => {
        function fuera(e: MouseEvent) {
            if (caja.current && !caja.current.contains(e.target as Node)) alCerrar()
        }
        function tecla(e: KeyboardEvent) {
            if (e.key === 'Escape') alCerrar()
        }
        document.addEventListener('mousedown', fuera)
        document.addEventListener('keydown', tecla)
        return () => {
            document.removeEventListener('mousedown', fuera)
            document.removeEventListener('keydown', tecla)
        }
    }, [alCerrar])

    const left = Math.min(x, typeof window !== 'undefined' ? window.innerWidth - 240 : x)
    const top = Math.min(y, typeof window !== 'undefined' ? window.innerHeight - 140 : y)

    return (
        <div
            ref={caja}
            role="menu"
            aria-label="Alcance del cambio de horario"
            data-testid="pregunta-alcance-horario"
            className="fixed z-50 w-60 overflow-hidden rounded-lg border border-neutral-700 bg-neutral-900 py-1 shadow-xl shadow-black/50"
            style={{ left, top }}
        >
            <button
                type="button"
                role="menuitem"
                onClick={alSoloEste}
                className="block min-h-11 w-full px-3 py-2 text-left text-sm text-neutral-100 hover:bg-neutral-800"
            >
                Solo este día
            </button>
            <button
                type="button"
                role="menuitem"
                onClick={alResto}
                className="block min-h-11 w-full px-3 py-2 text-left text-sm text-neutral-100 hover:bg-neutral-800"
            >
                Aplicar al resto de los días
            </button>
        </div>
    )
}
